import React, { useState, useRef, useCallback, useEffect } from "react";
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Select as MuiSelect,
  Grid,
  IconButton,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import CustomDatePicker from "../utilities/CustomDatePicker";
import moment from "moment";
import VoucherForm from "../voucher/VoucherForm";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import Select, { components } from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import jwtDecode from "jwt-decode";

const VoucherList = () => {

  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const gridRef = useRef();
  const navigate = useNavigate();
  const childRef = useRef();
  const [error, setError] = useState("");
  const [fromDate, setFromDate] = useState();
  const [fromError, setFromError] = useState();
  const [toError, setToError] = useState();
  const [toDate, setToDate] = useState();
  const [autoSizeMode, setAutoSizeMode] = useState(true)
  const [successMsg, setSuccessMsg] = useState();
  const [snackState, setSnackState] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [formOpen, setFormOpen] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [vouchertype, setVoucherType] = useState('ALL');
  const [voucherStatus, setVoucherStatus] = useState(['ALL']);
  const [voucherTypeOptions, setVoucherTypeOptions] = useState([]);
  const [listOptions, setListOptions] = useState([
    { label: 'All Vouchers', value: 'vouchers' },
    { label: 'Deleted Voucher', value: 'deleted' },
    { label: 'Pending Voucher', value: 'approval' },
  ]);
  const [voucherStatusOptions, setVoucherStatusOptions] = useState([
    { label: 'All', value: 'ALL' },
    { label: 'Pending', value: 'PENDING' },
    { label: 'Approved', value: 'APPROVED' },
    { label: 'Rejected', value: 'REJECTED' },
    { label: 'Deleted', value: 'DELETED' },
  ]);
  const [searchbarvalue, setSerchBarValue] = useState();
  const token = localStorage.getItem("token") && jwtDecode(localStorage.getItem("token"));

  const showAttachment = useCallback((props) => {
    return (
      props.value && (
        <IconButton
          size="small"
          className="p-0"
          onClick={() => showDocument(props.value)}
        >
          <FuseSvgIcon>heroicons-outline:paper-clip</FuseSvgIcon>
        </IconButton>
      )
    );
  });

  const showDocument = (document) => {
    handleDownloadAttachment(document)
  }
  const renderCurrency = (props) => {
    const options = {
      style: 'decimal',  // Other options: 'currency', 'percent', etc.
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    };

    const decimalValue = props?.value ? Number(props?.value) === 0 ? '0.00' : Number(props?.value).toLocaleString('en-US', options) : '0.00'
    return <span style={{ display: "flex" }}>
      <p>{decimalValue}</p>
    </span>;
  };
  const [columnDefs, setColumnDefs] = useState([
    {
      field: 'docDate', enableRowGroup: true, headerName: 'Doc Date',
      dateFormat: 'd/m/Y',
      valueFormatter: (params) => { return params.value ? moment(params.value).format('DD-MM-YYYY') : '' },
      cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      },
      rowSpan: function (params) {
        if (params?.data?.docDate !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      },
      checkboxSelection: params => params?.data?.docDate ? true : false
    },
    {
      field: 'postDate',
      enableRowGroup: true,
      valueFormatter: (params) => params.value ? moment(params.value).format('DD-MM-YYYY') : '',
      headerName: 'Post Date',
      dateFormat: 'd/m/Y',
      cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      },
      rowSpan: function (params) {
        if (params?.data?.postDate !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
    {
      field: 'voucherType', enableRowGroup: true, headerName: 'Type', filter: 'agTextColumnFilter',
      cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }, rowSpan: function (params) {
        if (params?.data?.voucherType !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
    {
      field: 'voucherNo', enableRowGroup: true, headerName: 'Voucher No.', cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }, rowSpan: function (params) {
        if (params?.data?.voucherNo !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
    {
      field: 'docDescription', enableRowGroup: true, headerName: 'Doc Description', filter: 'agTextColumnFilter', cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }, rowSpan: function (params) {
        if (params?.data?.docDescription !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
    {
      field: 'accountName', enableRowGroup: true, headerName: 'Account',
      cellClassRules: {
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }
    },
    {
      field: 'lineDescription', enableRowGroup: true, headerName: 'Line Description',
      cellClassRules: {
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }
    },
    {
      field: 'currency', enableRowGroup: true, headerName: 'Currency',
      cellClassRules: {
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }
    },
    {
      field: 'debit', enableRowGroup: true, headerName: 'Debit',
      cellClassRules: {
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      },
      valueFormatter: (params) => (params.value !== undefined && params.value !== null) ? Number(params.value).toFixed(2) : 0.00,
      cellRenderer: renderCurrency

    },
    {
      field: 'credit', enableRowGroup: true, headerName: 'Credit',
      cellClassRules: {
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      },
      valueFormatter: (params) => (params.value !== undefined && params.value !== null) ? Number(params.value).toFixed(2) : 0.00,
      cellRenderer: renderCurrency,
    },
    {
      field: 'invoiceDocument', enableRowGroup: true, headerName: 'Attachment', cellRenderer: showAttachment,
      cellClassRules: {
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      },
    },
    {
      field: 'createdBy', enableRowGroup: true, headerName: 'Created By',
      cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }, rowSpan: function (params) {
        if (params?.data?.voucherNo !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
    {
      field: 'approvedBy', enableRowGroup: true, headerName: 'Approved By', minWidth: 150, maxWidth: 150,
      cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }, rowSpan: function (params) {
        if (params?.data?.voucherNo !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
    {
      field: 'statusUpdatedBy', enableRowGroup: true, headerName: 'Updated By', minWidth: 150, maxWidth: 150,
      cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }, rowSpan: function (params) {
        if (params?.data?.voucherNo !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
    {
      field: 'rejectedBy', enableRowGroup: true, headerName: 'Rejected By', minWidth: 150, maxWidth: 150,
      cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }, rowSpan: function (params) {
        if (params?.data?.voucherNo !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
    {
      field: 'deletedBy', enableRowGroup: true, headerName: 'Deleted By',
      cellClassRules: {
        'show-cell': 'value !== undefined',
        'rag-blue-font': params => (params?.data?.status === 'PENDING'),
        'rag-green-font': params => (params?.data?.status === 'APPROVED'),
        'rag-red-font': params => (params?.data?.status === 'REJECTED'),
        'rag-purpleStatus-font': params => (params?.data?.reverseDocStatus !== null && params?.data?.status === 'PENDING'),
        'rag-purple-font': params => (params?.data?.voucherReference === 'REVERSE_REFERENCE' && params?.data?.status === 'APPROVED'),
      }, rowSpan: function (params) {
        if (params?.data?.voucherNo !== undefined) {
          return params?.data?.docrefCount;
        } else {
          return 1;
        }
      }
    },
  ]);
  const voucherTypeUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucherTypes}`;
  const voucherUrl = `${process.env.REACT_APP_FINANCE_API_KEY_URL}${oAuthServiceConfig.voucher}`;

  const handleFromDateChange = (value) => {
    setFromDate(value === null ? null : moment(value).format("YYYY-MM-DD"));
    value && setToDate(null);
    loadDataList(
      vouchertype,
      value === null ? null : moment(value).format("YYYY-MM-DD"),
      voucherStatus,
      value ? moment(new Date()).format("YYYY-MM-DD") : toDate
    );
  };

  const handleToDateChange = async (value) => {
    const endDate = value === null ? null : moment(value).format("YYYY-MM-DD");
    setToDate(endDate);
    !fromDate && endDate
      ? setFromError("Please select from date ")
      : setFromError("");
    loadDataList(vouchertype, fromDate, voucherStatus, endDate);
  };

  const handleAddButton = () => {
    if (selectedRows.length > 0 && (selectedRows.filter((value) => value.docRef !== null).length > 0 && selectedRows[0].status !== 'APPROVED')) {
      setError(`Creation of 'With Reference' & 'Reverse Reference' voucher is only allowed for Approved vouchers`)
    } else {
      setFormOpen(true);
      setError('')
    }
  };

  const handleFormClose = () => {
    setFormOpen(false);
  };

  const onGridReady = (params) => {
    setGridApi(params.api);
    loadDataList();
  };
  const handleSearchBarChange = useCallback(
    (event) => {
      const searchValue = event.target.value;
      setSerchBarValue(searchValue);
      const updatedCol = [...columnDefs];

      updatedCol.map((col) => {
        col.cellRenderer = (params) => {
          const cellValue = params.value != null ? params.value.toString() : "";
          const searchString =
            searchValue != null ? searchValue.toString() : "";
          const valueSearch = cellValue.split(
            new RegExp(`(${searchString})`, "gi")
          );

          return (
            <div>
              {valueSearch.map((value, index) => (
                <span
                  className={
                    value.toLowerCase() === searchString.toLowerCase()
                      ? "highlighted-cell"
                      : ""
                  }
                >
                  {value}
                </span>
              ))}
            </div>
          );
        };
        return col;
      });

      setColumnDefs(updatedCol);
    },
    [rowData]
  );

  const handleChangeVT = (event) => {
    setVoucherType(event.id);
    loadDataList(event.id, fromDate, voucherStatus, toDate);
  };

  const handleStatusChange = (event) => {
    let status = event.map((row) => {
      return row.value;
    });
    status = status.indexOf('ALL') === 0 && status.length > 1 ? status.includes("ALL") ? status.filter(value => value !== 'ALL') : status : status.includes("ALL") ? ['ALL'] : status;
    setVoucherStatus(status);
    loadDataList(vouchertype, fromDate, status, toDate);
    if (status.includes('ALL')) {
      gridRef?.current?.columnApi?.applyColumnState({
        state: [
          { colId: 'approvedBy', hide: false },
          { colId: 'deletedBy', hide: false },
          { colId: 'rejectedBy', hide: false },
        ],
      });
    } else if (status.includes('REJECTED')) {
      if (status.includes('DELETED') || status.includes('APPROVED')) {
        gridRef?.current?.columnApi?.applyColumnState({
          state: [
            { colId: 'approvedBy', hide: false },
            { colId: 'deletedBy', hide: false },
            { colId: 'rejectedBy', hide: false },
          ],
        });
      } else {
        gridRef?.current?.columnApi?.applyColumnState({
          state: [
            { colId: 'approvedBy', hide: true },
            { colId: 'deletedBy', hide: false },
            { colId: 'rejectedBy', hide: false },
          ],
        });
      }
    } else if (status.includes('DELETED')) {
      if (status.includes('REJECTED') || status.includes('APPROVED') || status.includes('PENDING')) {
        gridRef?.current?.columnApi?.applyColumnState({
          state: [
            { colId: 'approvedBy', hide: false },
            { colId: 'deletedBy', hide: false },
            { colId: 'rejectedBy', hide: false },
          ],
        });
      } else {
        gridRef?.current?.columnApi?.applyColumnState({
          state: [
            { colId: 'approvedBy', hide: false },
            { colId: 'deletedBy', hide: false },
            { colId: 'rejectedBy', hide: false },
          ],
        });
      }
    } else if (status.includes('PENDING')) {
      if (status.includes('DELETED') || status.includes('APPROVED') || status.includes('REJECTED')) {
        gridRef?.current?.columnApi?.applyColumnState({
          state: [
            { colId: 'approvedBy', hide: false },
            { colId: 'deletedBy', hide: false },
            { colId: 'rejectedBy', hide: false },
          ],
        });
      }else{
        gridRef?.current?.columnApi?.applyColumnState({
          state: [
            { colId: 'approvedBy', hide: true },
            { colId: 'deletedBy', hide: false },
            { colId: 'rejectedBy', hide: true },
          ],
        });
      }
    } else if (status.includes('APPROVED')) {
      if (status.includes('DELETED') || status.includes('APPROVED') || status.includes('REJECTED')) {
        gridRef?.current?.columnApi?.applyColumnState({
          state: [
            { colId: 'approvedBy', hide: false },
            { colId: 'deletedBy', hide: false },
            { colId: 'rejectedBy', hide: false },
          ],
        });
      }else{
      gridRef?.current?.columnApi?.applyColumnState({
        state: [
          { colId: 'approvedBy', hide: false },
          { colId: 'deletedBy', hide: false },
          { colId: 'rejectedBy', hide: true },
        ],
      });
    }
    }
    gridRef?.current?.api?.refreshCells();
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  };

  const commonDataUpdateLogic = (list) => {
    // onFirstDataRendered({ columnApi: gridRef.current.columnApi });
    setRowData(list);
    setSelectedRows([]);
  };

  useEffect(() => {
    commonDataUpdateLogic();
  }, []);

  const loadDataList = async (
    vouchertypes,
    fromdates,
    voucherStatuses,
    todates
  ) => {
    if (
      token?.scope?.includes("ROLE_FINANCE") ||
      token?.scope?.includes("ROLE_FINMGR")
    ) {
      let searchObj = { deleted: false };
      const voucherTypes = vouchertypes || vouchertype;
      const fromDates = fromdates || fromDate;
      const toDates = todates || toDate;
      const voucherStatuse = voucherStatuses || voucherStatus;
      if (voucherTypes !== "ALL") {
        searchObj = { ...searchObj, voucherType: voucherTypes };
      } else {
        delete searchObj.voucherType;
      }

      if (voucherStatuse.length === 0) {
        delete searchObj.statusList;
      } else {
        // const filterStatus = voucherStatuse.filter((data) => data !== "ALL");
        if (voucherStatuse.length > 0) {
          if (voucherStatuse.includes("DELETED")) {
            const other = voucherStatuse.filter((data) => data !== "DELETED");
            if (other.length > 0) {
              searchObj = { ...searchObj, statusList: other };
            }
            searchObj = { ...searchObj, deleted: true };
          } else {
            if (voucherStatuse.includes("ALL")) {
              delete searchObj.statusList;
              searchObj = { ...searchObj, statusList: ['REJECTED', 'APPROVED', 'PENDING'], deleted: true };
            } else {
              searchObj = { ...searchObj, statusList: voucherStatuse };
            }
          }
        } else {
          delete searchObj.statusList;
        }
      }
      if (fromDates) {
        searchObj = {
          ...searchObj,
          startDate: moment(fromDates).format("YYYY-MM-DD"),
        };
      }
      if (toDates) {
        searchObj = {
          ...searchObj,
          endDate: moment(toDates).format("YYYY-MM-DD"),
        };
      } else {
        if (fromDates) {
          searchObj = {
            ...searchObj,
            endDate: moment(new Date()).format("YYYY-MM-DD"),
          };
        }
      }
      const loadData = await OAuthService.addData(
        voucherUrl + "/searchVoucher",
        searchObj
      );
      let list = loadData?.data.map((data) => {
        data.accountName = data?.accountNumber + " " + data?.accountName;
        data.voucherTypeId = data?.voucherType?.id;
        data.voucherTypeShortKey = data?.voucherType?.shortKey;
        data.voucherType = data?.voucherType?.shortKey;
        return data;
      });
      let docRefsCount = [];
      list = list.map((data) => {
        if (docRefsCount[data.docRef] || docRefsCount[data.docRef] >= 1) {
          docRefsCount[data.docRef] = docRefsCount[data.docRef] + 1;
          data.docDate = undefined;
          data.postDate = undefined;
          data.docDescription = undefined;
          data.voucherType = undefined;
          data.voucherNo = undefined;
        } else {
          docRefsCount[data.docRef] = 1;
        }
        return data;
      });
      const userUrl = `${process.env.REACT_APP_API_KEY_URL}${oAuthServiceConfig.users}`;

      const userlist = await OAuthService.getList(
        userUrl + `?sort=firstName,asc&size=1000`
      );
      const users = [];
      userlist.data?._embedded?.users.map((data, key) => {
        data.name = data.firstName + " " + data.lastName;
        users[data.email] = data.name;
        return data;
      });
      list = list.map((data) => {
        data.docrefCount = docRefsCount[data.docRef];
        data.createdBy = data.createdBy && users[data.createdBy];
        data.statusUpdatedBy = data.statusUpdatedBy && (users[data.statusUpdatedBy] + ' ' + (data?.statusUpdatedAt && moment(data?.statusUpdatedAt).format('DD-MM-YYYY')));
        data.rejectedBy = data?.rejectedBy && (users[data.rejectedBy] + ' ' + (data?.rejectedAt && moment(data?.rejectedAt).format('DD-MM-YYYY')));
        data.deletedBy = data?.deletedBy && (users[data.deletedBy] + ' ' + (data?.deletedAt && moment(data?.deletedAt).format('DD-MM-YYYY')));
        data.approvedBy = data?.approvedBy && (users[data.approvedBy]);
        return data;
      });
      setRowData(list);
      setSelectedRows([]);
      commonDataUpdateLogic(list);
    } else {
      setError("You don't have privileges to view Vouchers");
    }
  };

  const handleDownloadAttachment = async (selectedDocument) => {
    const downloadUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.fileDownload}`;
    const download = await OAuthService.getDownload(
      downloadUrl + `/${selectedDocument}`
    );
    const blob = download?.data;
    if (blob) {
      const url = window.URL.createObjectURL(
        new Blob([blob], { type: "application/octet-stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = selectedDocument;
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
    }
  };

  useEffect(() => {
    const voucherTypes = async () => {
      const types = await OAuthService.getList(voucherTypeUrl);
      let vouchers = types?.data?._embedded?.voucherTypes?.map((type) => {
        return {
          label: type.shortKey + " " + type.description,
          value: type.shortKey,
          id: type?._links?.self?.href.split("/").pop(),
        };
      });
      vouchers = [{ label: "ALL", value: "ALL", id: "ALL" }, ...vouchers];
      if (vouchers && vouchers.length > 0) {
        setVoucherTypeOptions(vouchers);
      }
    };

    voucherTypes();
  }, []);

  const handleRejectVoucher = async () => {
    const docRefId = selectedRows.length > 0 && selectedRows.map((data) => data.docRef)
    try {
      const voucher = await OAuthService.addData(voucherUrl + `/updateStatus`, {
        "docRef": docRefId,
        // "comment": "",
        "status": "REJECTED"
      })
      if (voucher?.data) {
        setSuccessMsg("Voucher Rejected successfully.");
        setSnackState(true)
        loadDataList(vouchertype, fromDate, voucherStatus, toDate)
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message)
    }
  }
  const handleApproveVoucher = async () => {
    const docRefId = selectedRows.length > 0 && selectedRows.map((data) => data.docRef)
    try {
      const voucher = await OAuthService.addData(voucherUrl + `/updateStatus`, {
        "docRef": docRefId,
        "status": "APPROVED"
      })
      if (voucher?.data) {
        setSuccessMsg("Voucher Approved successfully.")
        setSnackState(true);
        loadDataList(vouchertype, fromDate, voucherStatus, toDate)
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message)
    }
  }

  const handleEditVoucher = () => {
    const id = selectedRows[0].docRef;
    navigate(`/editVoucher/${id}`);
  };

  const handleViewVoucher = () => {
    const viewid = selectedRows[0].docRef;
    navigate(`/viewVoucher/${viewid}`);
  };

  const handleDeleteVoucher = async () => {
    const docRefId = selectedRows.length > 0 && selectedRows.map((data) => data.docRef)
    try {
      const voucher = await OAuthService.addData(
        voucherUrl + `/deleteVoucher`, docRefId
      );
      if (voucher?.data) {
        loadDataList();
        setSuccessMsg("Voucher deleted successfully.");
        setSnackState(true);
        setDeleteOpen(false);
      }
    } catch (error) {
      setError(error?.response?.data?.errorMessage || error.message);
    }
  };

  const VoucherFilter = () => {
    return (
      <>
        {(token?.scope?.includes("ROLE_FINANCE") ||
          token?.scope?.includes("ROLE_FINMGR")) && (
            <Tooltip title={"Add Voucher"}>
              <Button
                variant="contained"
                color="warning"
                style={{ marginLeft: "3px" }}
                onClick={handleAddButton}
                disabled={selectedRows.length > 0 ? selectedRows.length === 1 ? (selectedRows && selectedRows.filter((row) => row.status === "PENDING" || row.status === "REJECTED").length > 0) ? true : false : true : false}
              >
                <FuseSvgIcon>heroicons-solid:plus-circle</FuseSvgIcon>
              </Button>
            </Tooltip>
          )}
        {selectedRows &&
          selectedRows.length > 0 &&
          (token?.scope?.includes("ROLE_FINANCE") ||
            token?.scope?.includes("ROLE_FINMGR")) && (
            <>

              <Tooltip title={"Edit Voucher"}>
                <Button
                  variant="contained"
                  color="warning"
                  style={{ marginLeft: "3px" }}
                  onClick={handleEditVoucher}
                  disabled={selectedRows.length === 1 ? selectedRows.filter((row) => (token?.scope?.includes("ROLE_FINANCE") && row.status === "APPROVED") || row.isDeleted === true).length > 0 ? true : false : true}
                >
                  <FuseSvgIcon>heroicons-solid:pencil</FuseSvgIcon>
                </Button>
              </Tooltip>

              <Tooltip title={"View Voucher"}>
                <Button
                  variant="contained"
                  color="warning"
                  style={{ marginLeft: "3px" }}
                  onClick={handleViewVoucher}
                  disabled={selectedRows.length === 1 ? selectedRows.filter((row) => (row.isDeleted === true)).length > 0 ? true : false : true}
                >
                  <FuseSvgIcon>heroicons-solid:eye</FuseSvgIcon>
                </Button>
              </Tooltip>
            </>
          )}

        {selectedRows &&
          selectedRows.length > 0 &&
          token?.scope?.includes("ROLE_FINMGR") && (
            <>
              <Tooltip title={"Approve Voucher"}>
                <Button
                  variant="contained"
                  color="warning"
                  disabled={selectedRows.filter((row) => row.status !== "PENDING" || row.isDeleted === true).length > 0 ? true : false}
                  style={{ marginLeft: "3px" }}
                  onClick={handleApproveVoucher}
                >
                  <FuseSvgIcon>heroicons-outline:check-circle</FuseSvgIcon>
                </Button>
              </Tooltip>
              <Tooltip title={"Reject Voucher"}>
                <Button
                  variant="contained"
                  color="warning"
                  disabled={selectedRows.filter((row) => row.status !== "PENDING" || row.isDeleted === true).length > 0 ? true : false}
                  style={{ marginLeft: "3px" }}
                  onClick={handleRejectVoucher}
                >
                  <FuseSvgIcon>heroicons-outline:x-circle</FuseSvgIcon>
                </Button>
              </Tooltip>
            </>
          )}

        {selectedRows &&
          selectedRows.length > 0 &&
          (token?.scope?.includes("ROLE_FINANCE") ||
            token?.scope?.includes("ROLE_FINMGR")) && (
            <Tooltip title={"Delete Voucher"}>
              <Button
                variant="contained"
                color="warning"
                style={{ marginLeft: "3px" }}
                onClick={() => setDeleteOpen(true)}
                disabled={selectedRows.filter((row) => (token?.scope?.includes("ROLE_FINANCE") && row.status === "APPROVED") || row.isDeleted === true).length > 0 ? true : false}
              >
                <FuseSvgIcon>heroicons-solid:trash</FuseSvgIcon>
              </Button>
            </Tooltip>
          )}
        {selectedRows &&
          selectedRows.length > 0 &&
          (token?.scope?.includes("ROLE_FINANCE") ||
            token?.scope?.includes("ROLE_FINMGR")) && (
            <Tooltip title={"Print Voucher"}>
              <Button
                variant="contained"
                color="warning"
                style={{
                  marginBottom: "5px",
                  fontWeight: "bold",
                  marginLeft: "3px",
                }}
                onClick={handleViewPrintVoucher}
                disabled={selectedRows.filter((row) => (row.isDeleted === true)).length > 0 ? true : false}
              >
                <FuseSvgIcon className="text-xl">
                  heroicons-outline:printer
                </FuseSvgIcon>
              </Button>
            </Tooltip>
          )}
        <Button
          onClick={toggleAutoSize}
          variant="contained"
          color="error"
          sx={{ height: 30, minHeight: 30, maxHeight: 30, fontSize: 11 }}
        >
          {!autoSizeMode ? 'Auto-Size Columns' : 'Reset Columns'}
        </Button>
        {/* </div > */}
      </>
    );
  };

  const toggleAutoSize = () => {
    if (gridRef.current) {
      const allColumnIds = []
      gridRef.current.columnApi.getColumns().forEach((column) => {
        allColumnIds.push(column.getId());
      })
      if (autoSizeMode) {
        gridRef.current?.columnApi?.resetColumnState();
        gridRef?.current?.columnApi?.autoSizeAllColumns();
        // gridRef.current?.columnApi?.autoSizeColumns(allColumnIds, false);
      } else {
        gridRef.current?.columnApi?.resetColumnState();
        // gridRef.current?.columnApi?.autoSizeColumns(allColumnIds, true);
      }

      setAutoSizeMode(!autoSizeMode)
    }
  }

  const handleSave = () => {
    const childelement = childRef.current;
    childelement.handleSubmit();
  };

  const checkSaveDisabled = (value) => {
    setSaveDisabled(value);
  };

  useEffect(() => {
    checkSaveDisabled();
  }, []);

  const handleDeleteClose = () => {
    setDeleteOpen(false);
  };

  const CheckboxOption = ({ innerProps, label, isSelected }) => (
    <div {...innerProps}>
      <input type="checkbox" checked={isSelected} onChange={() => null} />
      <span style={{ marginLeft: "2px" }}>{label}</span>
    </div>
  );

  const handleViewPrintVoucher = async () => {
    if (selectedRows.length > 0) {
      await Promise.all(selectedRows.map(async (row) => {
        if (row.docRef) {
          const voucherNo = row.docRef;
          const voucher = await OAuthService.getPdf(
            voucherUrl + `/printVoucher/${voucherNo}`
          );

          const file = new Blob([voucher?.data], {
            type: "application/pdf",
          });

          const fileURL = URL.createObjectURL(file);
          window.open(fileURL, '_blank');
        }
      }))
    }
  };

  // const ValueContainer = ({
  //   children,
  //   ...props
  // }) => {
  //   let [values, input] = children;
  //
  //   if (Array.isArray(values)) {
  //     const plural = values.length === 1 ? "" : "s";
  //     values = `${values.length} item${plural} selected`;
  //   }
  //
  //   return (
  //     <components.ValueContainer {...props}>
  //       {values}
  //       {input}
  //     </components.ValueContainer>
  //   );
  // };

  const onFirstDataRendered = useCallback(() => {
    const allColumnIds = []
    gridRef.current.columnApi.getColumns().forEach((column) => {
      allColumnIds.push(column.getId());
    })
    gridRef.current.columnApi.autoSizeColumns(allColumnIds, true);
  }, [])

  return (
    <>
      <ListPageHeader
        componentName="Voucher"
        headerInputFields={VoucherFilter()}
        pageName="Voucher List"
        error={error}
        successMsg={successMsg}
        snackState={snackState}
        gridRef={gridRef}
        showPaginationDropdown={false}
        headerFieldsBottom={'voucherHeaderRight sm:flex-col'}
      />
      <Stack direction={'row'} className="mb-10 md:px-16 self-end ">
        {(token?.scope?.includes('ROLE_FINANCE') || token?.scope?.includes('ROLE_FINMGR')) && <div className="flex flex-row">
          <div className="flex flex-row justify-between items-baseline">
            <Stack direction={'row'} className="self-end">
              <TextField
                name='searchbarvalue'
                value={searchbarvalue}
                onChange={handleSearchBarChange}
                placeholder="Search"
                inputProps={{
                  sx: { 'padding': '10px' },
                }}
              />
            </Stack>

            <Stack className="ml-10">
              <label className="pt-12 min-w-fit">Voucher Type</label>
              <Select
                name="vouchertype"
                className=" min-w-[250px]"
                value={(vouchertype && voucherTypeOptions.length > 0) && voucherTypeOptions.filter((list) => list.id === vouchertype)}
                onChange={handleChangeVT}
                options={voucherTypeOptions}
                styles={customStyles('', '', '0px')}
                components={{
                  Option: (optionProps) => (
                    <CheckboxOption
                      {...optionProps}
                      isSelected={optionProps.isSelected}
                    />
                  ),
                }}
              />
            </Stack>
            <Stack className="ml-10">
              <label className="min-w-fit">From Date </label>
              <div className="grid">
                <CustomDatePicker
                  className="w-[157px] h-[20px]"
                  format={'dd-MM-yyyy'}
                  name={'fromDate'}
                  value={fromDate}
                  handleChange={handleFromDateChange}
                  componentsProps={{
                    actionBar: { actions: ["clear"] },
                  }}
                  renderInput={(params) => <TextField size="small" InputLabelProps={{
                  }} {...params} sx={{
                    backgroundColor: props.viewData && '#8080800f'
                  }} />}
                />
              </div>
            </Stack>
            <Stack className="ml-10">
              <label className="min-w-fit">To Date </label>
              <div className="grid">
                <CustomDatePicker
                  className="w-[157px] h-[20px]"
                  format={'dd-MM-yyyy'}
                  name={'toDate'}
                  value={toDate}
                  minDate={new Date(fromDate).setDate((new Date(new Date(fromDate).getTime())).getDate() + 30)}
                  handleChange={handleToDateChange}
                  componentsProps={{
                    actionBar: { actions: ["clear"] },
                  }}
                  renderInput={(params) => <TextField size="small" InputLabelProps={{
                  }} {...params} sx={{
                    backgroundColor: props.viewData && '#8080800f'
                  }} />}
                />
              </div>
            </Stack>
            <Stack className="ml-10">
              <label className="pt-12 min-w-fit">Status</label>
              <Select
                name="status"
                className=" min-w-[150px]"
                value={(voucherStatus && voucherStatusOptions.length > 0) && voucherStatusOptions.filter((list) => voucherStatus.includes(list.value))}
                onChange={handleStatusChange}
                isMulti={true}
                hideSelectedOptions={false}
                options={voucherStatusOptions}
                styles={customStyles('', '', '0px')}
                components={{
                  // ValueContainer: ValueContainer,
                  Option: (optionProps) => (
                    <CheckboxOption
                      {...optionProps}
                      isSelected={optionProps.isSelected}

                    />
                  ),
                }}
              />
            </Stack>
          </div>
        </div>}
      </Stack>
      <div className="h-full">
        <AgGridTable
          rowData={rowData}
          columnDefs={columnDefs}
          onGridReady={onGridReady}
          gridRef={gridRef}
          onSelectionChanged={onSelectionChanged}
          saveGridStateName={'voucherList'}
          groupCheckBox={false}
          wrapHeaderText={true}
          suppressRowTransform={true}
          suppressContextMenu={true}
          autoHeaderHeight={true}
          onFirstDataRendered={onFirstDataRendered}
          pagination={false}
          editable={false}
        />
      </div>
      <Dialog
        fullWidth={true}
        PaperProps={{
          sx: {
            // overflow-scroll
            minHeight: 480,
            // overflowY: 'hidden'
            // height:'inherit'
          }
        }}
        maxWidth={'sm'}
        onClose={handleFormClose}
        open={formOpen}
      >
        <DialogTitle>
          <div className="flex flex-col sm:flex-row space-y-16 sm:space-y-0">
            <span>Add Voucher</span>
            <div className="flex flex-col w-full sm:w-auto sm:flex-row space-y-16 sm:space-y-0 flex-1 items-center justify-end space-x-8">
              <Button onClick={handleFormClose}><FuseSvgIcon>heroicons-solid:x</FuseSvgIcon></Button>
            </div>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          <VoucherForm
            ref={childRef}
            selectrowPros={selectedRows}
            checkSaveDisabled={checkSaveDisabled}
          />
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="warning"
            onClick={handleSave}
            disabled={saveDisabled}
          >
            <FuseSvgIcon>heroicons-solid:plus</FuseSvgIcon>
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={deleteOpen}
        onClose={handleDeleteClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteVoucher}>Yes</Button>
          <Button onClick={handleDeleteClose} autoFocus>
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default VoucherList;
